/**
 * Behaviors for header handheld tabs
 */
(function (Drupal, $, once) {
  Drupal.behaviors.rmccHandheldTabs = {
    attach(context, settings) {
      once('rmccTabsBehavior', '.page-header--handheld', context).forEach(() => {

        // Cache util elements
        let $tabsContext = $('.handheld-layout__tabs'),
            $tabNav      = $(' > ul', $tabsContext),
            $tabNavItems = $('> li', $tabNav);

        $tabsContext.tabs({
          active:      false,
          collapsible: true,
          show:        {effect: "slideDown", duration: 300},
          hide:        {effect: "slideUp", duration: 300},
          activate:    (event, ui) => {

            // If there are active tabs set disabled classes for styling purposes else remove
            if ($('> li.ui-state-active', $tabNav).length) {
              $tabNavItems.each((i, elem) => {
                $(elem).addClass('disabled');
              });
              $(ui.newTab).removeClass('disabled');

              // If it's search tab focus on text field
              if ($(ui.newTab).hasClass('handheld-tabs__nav-item--search')) {
                $('.form-text', $(ui.newPanel)).focus();
              }
            }
            else {
              $tabNavItems.each((i, elem) => {
                $(elem).removeClass('disabled');
              });
            }

          }
        });

      });
    }
  };


  /**
   * Behaviors for search block
   */
  Drupal.behaviors.rmccHeaderSearch = {
    attach(context, settings) {
      once('rmccHeaderSearchBehavior', '.block-header-search-form', context).forEach(() => {

        let $context     = $('.block-header-search-form'),
            $revealer    = $('.header-search__reaveler', $context),
            $form        = $('form', $context),
            $searchInput = $('.form-item-search-stories input', $form);

        $searchInput.attr('placeholder', 'Search');

        $revealer.on('click', (e) => {
          $form.toggleClass('active');
          $revealer.toggleClass('close');
          $form.toggle();
          $searchInput.focus();
        });
      });
    }
  };
}) (Drupal, jQuery, once);
